const CLOUDINARY_URL =
  "https://res.cloudinary.com/ag-millworks/image/upload/Swing_Configs";

export const taggedSwingConfigsAlum = [
  {
    swingDirection: "Outswing",
    SwingType: "Pair Swing",
    Sidelites: "Add Double Sidelite",
    label: "Outswing Pair 2 Sidelite",
    img1: `${CLOUDINARY_URL}/outswing/Aluminum/LH_PAIR_2xSL.jpg`,
    img2: `${CLOUDINARY_URL}/outswing/Aluminum/RH_PAIR_2xSL.jpg`,
    img1M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OSLH_PR_2XSL-M.jpg`,
    img2M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OSRH_PR_2XSL-M.jpg`,
  },
  {
    swingDirection: "Outswing",
    SwingType: "Pair Swing",
    Sidelites: "Add Single Sidelite",
    label: "Outswing Pair 1 Sidelite",
    img1: `${CLOUDINARY_URL}/outswing/Aluminum/LH_PAIR_LEFT_SL.jpg`,
    img2: `${CLOUDINARY_URL}/outswing/Aluminum/RH_PAIR_LEFT_SL.jpg`,
    img4: `${CLOUDINARY_URL}/outswing/Aluminum/RH_PAIR_RIGHT_SL.jpg`,
    img3: `${CLOUDINARY_URL}/outswing/Aluminum/LH_PAIR_RIGHT_SL.jpg`,
    img1M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OS_SINGLE_LH_SL.jpg`,
    img2M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OS_SINGLE_LH_SL.jpg`,
    img3M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OS_SINGLE_LH_SL_LOCK.jpg`,
    img4M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OS_SINGLE_RH_SL_LOCK.jpg`,
  },
  {
    swingDirection: "Outswing",
    SwingType: "Pair Swing",
    Sidelites: "none",
    label: "Outswing Pair",
    img1: `${CLOUDINARY_URL}/outswing/Aluminum/LH_PAIR.jpg`,
    img2: `${CLOUDINARY_URL}/outswing/Aluminum/RH_PAIR.jpg`,
    img1M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OSLH_PR-M.jpg`,
    img2M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OSRH-PR-M.jpg`,
  },
  {
    swingDirection: "Outswing",
    SwingType: "Single Swing",
    Sidelites: "Add Single Sidelite",
    label: "Outswing Single 1 Sidelite",
    img1: `${CLOUDINARY_URL}/outswing/Aluminum/LH_SINGLE_LEFT_SL.jpg`,
    img2: `${CLOUDINARY_URL}/outswing/Aluminum/RH_SINGLE_RIGHT_SL.jpg`,
    img3: `${CLOUDINARY_URL}/outswing/Aluminum/LH_SINGLE_RIGHT_SL_LOCK.jpg`,
    img4: `${CLOUDINARY_URL}/outswing/Aluminum/RH_SINGLE_LEFT_SL_LOCK.jpg`,
    img1M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OSLH_1xSL-M.jpg`,
    img2M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OSRH_1xSL-M.jpg`,
    img3M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OSLH_SINGLE_SL_LOCK.jpg`,
    img4M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OSRH_SINGLE_SL_LOCK.jpg`,
  },
  {
    swingDirection: "Outswing",
    SwingType: "Single Swing",
    Sidelites: "Add Double Sidelite",
    label: "Outswing Single 2 Sidelite",
    img1: `${CLOUDINARY_URL}/outswing/Aluminum/LH_SINGLE_2xSL.jpg`,
    img2: `${CLOUDINARY_URL}/outswing/Aluminum/RH_SINGLE_2xSL.jpg`,
    img1M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OSLH_2XSL-M.jpg`,
    img2M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OSRH_2XSL-M.jpg`,
  },
  {
    swingDirection: "Outswing",
    SwingType: "Single Swing",
    Sidelites: "none",
    label: "Outswing Single",
    img1: `${CLOUDINARY_URL}/outswing/Aluminum/LH_SINGLE.jpg`,
    img2: `${CLOUDINARY_URL}/outswing/Aluminum/RH_SINGLE.jpg`,
    img1M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OSLH-M.jpg`,
    img2M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OSRH-M.jpg`,
  },
  {
    swingDirection: "Inswing",
    SwingType: "Pair Swing",
    Sidelites: "Add Double Sidelite",
    label: "Inswing Pair 2 Sidelite",
    img1: `${CLOUDINARY_URL}/inswing/Aluminum/LH_PAIR_2xSL.jpg`,
    img2: `${CLOUDINARY_URL}/inswing/Aluminum/RH_PAIR_2xSL.jpg`,
    img1M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_PAIR_LH_2XSL.jpg`,
    img2M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_PAIR_RH_2XSL.jpg`,
  },
  {
    swingDirection: "Inswing",
    SwingType: "Pair Swing",
    Sidelites: "Add Single Sidelite",
    label: "Inswing Pair 1 Sidelite",
    img1: `${CLOUDINARY_URL}/inswing/Aluminum/LH_PAIR_LEFT_SL.jpg`,
    img2: `${CLOUDINARY_URL}/inswing/Aluminum/RH_PAIR_LEFT_SL.jpg`,
    img4: `${CLOUDINARY_URL}/inswing/Aluminum/RH_PAIR_RIGHT_SL.jpg`,
    img3: `${CLOUDINARY_URL}/inswing/Aluminum/LH_PAIR_RIGHT_SL.jpg`,
    img1M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_LH_SL.jpg`,
    img2M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_RH_SL.jpg`,
    img3M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_LH_SL_LOCK.jpg`,
    img4M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_RH_SL_LOCK.jpg`,
  },
  {
    swingDirection: "Inswing",
    SwingType: "Pair Swing",
    Sidelites: "none",
    label: "Inswing Pair",
    img1: `${CLOUDINARY_URL}/inswing/Aluminum/LH_PAIR.jpg`,
    img2: `${CLOUDINARY_URL}/inswing/Aluminum/RH_PAIR.jpg`,
    img1M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_PAIR_LH.jpg`,
    img2M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_PAIR_RH.jpg`,
  },
  {
    swingDirection: "Inswing",
    SwingType: "Single Swing",
    Sidelites: "Add Single Sidelite",
    label: "Inswing Single 1 Sidelite ",
    img1: `${CLOUDINARY_URL}/inswing/Aluminum/LH_SINGLE_LEFT_SL.jpg`,
    img2: `${CLOUDINARY_URL}/inswing/Aluminum/RH_SINGLE_RIGHT_SL.jpg`,
    img4: `${CLOUDINARY_URL}/inswing/Aluminum/RH_SINGLE_LEFT_SL_LOCK.jpg`,
    img3: `${CLOUDINARY_URL}/inswing/Aluminum/LH_SINGLE_RIGHT_SL_LOCK.jpg`,
    img1M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_LH_SL.jpg`,
    img2M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_RH_SL.jpg`,
    img3M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_LH_SL_LOCK.jpg`,
    img4M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_RH_SL_LOCK.jpg`,
  },
  {
    swingDirection: "Inswing",
    SwingType: "Single Swing",
    Sidelites: "Add Double Sidelite",
    label: "Inswing Single 2 Sidelite",
    img1: `${CLOUDINARY_URL}/inswing/Aluminum/LH_SINGLE_2xSL.jpg`,
    img2: `${CLOUDINARY_URL}/inswing/Aluminum/RH_SINGLE_2xSL.jpg`,
    img1M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_LH_2XSL.jpg`,
    img2M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_RH_2XSL.jpg`,
  },
  {
    swingDirection: "Inswing",
    SwingType: "Single Swing",
    Sidelites: "none",
    label: "Inswing Single",
    img1: `${CLOUDINARY_URL}/inswing/Aluminum/LH_SINGLE.jpg`,
    img2: `${CLOUDINARY_URL}/inswing/Aluminum/RH_SINGLE.jpg`,
    img1M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_LH.jpg`,
    img2M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_RH.jpg`,
  },
];

export const equalPanelsSwingAlum = [
  {
    swingDirection: "Outswing",
    SwingType: "Pair Swing",
    Sidelites: "Add Double Sidelite",
    label: "Outswing Pair 2 Sidelite",
    img1: `${CLOUDINARY_URL}/outswing/Aluminum/LH_PAIR_2xSL_EVEN.jpg`,
    img2: `${CLOUDINARY_URL}/outswing/Aluminum/RH_PAIR_2xSL_EVEN.jpg`,
    img1M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OSLH_PR_2XSL-M.jpg`,
    img2M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OSRH_PR_2XSL-M.jpg`,
  },
  {
    swingDirection: "Outswing",
    SwingType: "Pair Swing",
    Sidelites: "Add Single Sidelite",
    label: "Outswing Pair 1 Sidelite",  
    img1: `${CLOUDINARY_URL}/outswing/Aluminum/LH_PAIR_LEFT_SL_EVEN.jpg`,
    img2: `${CLOUDINARY_URL}/outswing/Aluminum/RH_PAIR_LEFT_SL_EVEN.jpg`,
    img3: `${CLOUDINARY_URL}/outswing/Aluminum/LH_PAIR_RIGHT_SL_EVEN.jpg`,
    img4: `${CLOUDINARY_URL}/outswing/Aluminum/RH_PAIR_RIGHT_SL_EVEN.jpg`,
    img1M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OS_SINGLE_LH_SL.jpg`,
    img2M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OS_SINGLE_RH_SL.jpg`,
    img3M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OS_SINGLE_LH_SL_LOCK.jpg`,
    img4M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OS_SINGLE_RH_SL_LOCK.jpg`,
  },
  {
    swingDirection: "Outswing",
    SwingType: "Single Swing",
    Sidelites: "Add Single Sidelite",
    label: "Outswing Single 1 Sidelite",
    img1: `${CLOUDINARY_URL}/outswing/Aluminum/LH_SINGLE_LEFT_SL_EVEN.jpg`,
    img2: `${CLOUDINARY_URL}/outswing/Aluminum/RH_SINGLE_RIGHT_SL_EVEN.jpg`,
    img3: `${CLOUDINARY_URL}/outswing/Aluminum/LH_SINGLE_RIGHT_SL_EVEN_LOCK.jpg`,
    img4: `${CLOUDINARY_URL}/outswing/Aluminum/RH_SINGLE_LEFT_SL_EVEN_LOCK.jpg`,
    img1M: `${CLOUDINARY_URL}/outswing /Aluminum/measurements/OS_SINGLE_LH_SL.jpg`,
    img2M: `${CLOUDINARY_URL}/outswing /Aluminum/measurements/OS_SINGLE_RH_SL.jpg`,
    img3M: `${CLOUDINARY_URL}/outswing /Aluminum/measurements/OS_SINGLE_LH_SL_LOCK.jpg`,
    img4M: `${CLOUDINARY_URL}/outswing /Aluminum/measurements/OS_SINGLE_RH_SL_LOCK.jpg`,
  },
  {
    swingDirection: "Outswing",
    SwingType: "Single Swing",
    Sidelites: "Add Double Sidelite",
    label: "Outswing Single 2 Sidelite",
    img1: `${CLOUDINARY_URL}/outswing/Aluminum/LH_SINGLE_2xSL_EVEN.jpg`,
    img2: `${CLOUDINARY_URL}/outswing/Aluminum/RH_SINGLE_2xSL_EVEN.jpg`,
    img1M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OSLH_2XSL-M.jpg`,
    img2M: `${CLOUDINARY_URL}/outswing/Aluminum/measurements/OSRH_2XSL-M.jpg`,
  },
  {
    swingDirection: "Inswing",
    SwingType: "Pair Swing",
    Sidelites: "Add Double Sidelite",
    label: "Inswing Pair 2 Sidelite",
    img1: `${CLOUDINARY_URL}/inswing/Aluminum/LH_PAIR_2xSL_EVEN.jpg`,
    img2: `${CLOUDINARY_URL}/inswing/Aluminum/RH_PAIR_2xSL_EVEN.jpg`,
    img1M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_PAIR_LH_2XSL.jpg`,
    img2M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_PAIR_RH_2XSL.jpg`,
  },
  {
    swingDirection: "Inswing",
    SwingType: "Pair Swing",
    Sidelites: "Add Single Sidelite",
    label: "Inswing Pair 1 Sidelite",
    img1: `${CLOUDINARY_URL}/inswing/Aluminum/LH_PAIR_LEFT_SL_EVEN.jpg`,
    img2: `${CLOUDINARY_URL}/inswing/Aluminum/RH_PAIR_LEFT_SL_EVEN.jpg`,
    img3: `${CLOUDINARY_URL}/inswing/Aluminum/LH_PAIR_RIGHT_SL_EVEN.jpg`,
    img4: `${CLOUDINARY_URL}/inswing/Aluminum/RH_PAIR_RIGHT_SL_EVEN.jpg`,
    img1M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_LH_SL.jpg`,
    img2M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_RH_SL.jpg`,
    img3M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_LH_SL_LOCK.jpg`,
    img4M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_RH_SL_LOCK.jpg`,
  },
  {
    swingDirection: "Inswing",
    SwingType: "Single Swing",
    Sidelites: "Add Single Sidelite",
    label: "Inswing Single 1 Sidelite ",
    img1: `${CLOUDINARY_URL}/inswing/Aluminum/LH_SINGLE_LEFT_SL_EVEN.jpg`,
    img2: `${CLOUDINARY_URL}/inswing/Aluminum/RH_SINGLE_RIGHT_SL_EVEN.jpg`,
    img3: `${CLOUDINARY_URL}/inswing/Aluminum/LH_SINGLE_RIGHT_SL_EVEN_LOCK.jpg`,
    img4: `${CLOUDINARY_URL}/inswing/Aluminum/RH_SINGLE_LEFT_SL_EVEN_LOCK.jpg`,
    img1M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_LH_SL.jpg`,
    img2M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_RH_SL.jpg`,
    img3M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_LH_SL_LOCK.jpg`,
    img4M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_RH_SL_LOCK.jpg`,
  },
  {
    swingDirection: "Inswing",
    SwingType: "Single Swing",
    Sidelites: "Add Double Sidelite",
    label: "Inswing Single 2 Sidelite",
    img1: `${CLOUDINARY_URL}/inswing/Aluminum/LH_SINGLE_2xSL_EVEN.jpg`,
    img2: `${CLOUDINARY_URL}/inswing/Aluminum/RH_SINGLE_2xSL_EVEN.jpg`,
    img1M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_LH_2XSL.jpg`,
    img2M: `${CLOUDINARY_URL}/inswing/Aluminum/measurements/IS_SINGLE_RH_2XSL.jpg`,
  },
];
